export enum EdgeIndex {
  LEFT = 0,
  BOTTOM = 1,
  RIGHT = 2,
  TOP = 3,
}
